import { ReactElement } from 'react'
import {
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  TableWrapper,
  TableHeader,
  PageWrapper,
  SectionTitle
} from '../../../../components'
import strings from '../../../../locale/en'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { TableRow } from './subcomponents'

const TestResults = (): ReactElement => {
  const {
    batchDetails: {
      batchName,
      branchName,
      instituteName,
      placeholders: { selectInstitute, selectBranchName, selectBatch }
    },
    menu: {
      admin: {
        createTest: { testResults }
      }
    }
  } = strings

  return (
    <PageWrapper id="container">
      <SectionTitle title={testResults} />
      <FlexWrapper>
        <DropdownWrapper>
          <EditableDropdown
            title={instituteName}
            isRequired
            dropdownList={[]}
            placeholder={selectInstitute}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            title={branchName}
            isRequired
            dropdownList={[]}
            placeholder={selectBranchName}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={selectBatch}
            placeholder={batchName}
            onBlur={() => {}}
            isRequired
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
      </FlexWrapper>
      <TableWrapper>
        <Table size="sm" responsive="sm">
          <TableHeader>
            <TableRow>
              {tableHeader?.map((header, index) => (
                <th key={`test-listing-header-${index}`}>{header}</th>
              ))}
            </TableRow>
          </TableHeader>
          <tbody>
            <td>{'Test name'}</td>
            <td>{'20'}</td>
            <td>{'30 mins'}</td>
            <td>{'04/12/2021'}</td>
          </tbody>
        </Table>
      </TableWrapper>
    </PageWrapper>
  )
}

export default TestResults
